import { useId } from 'react'
import { Input } from '@/atoms/Input'
import { Label } from '@/atoms/Label'

export type FormFieldProps = {
  label: string
  name: string
  type?: 'text' | 'email' | 'password'
  value: string
  autoComplete?: string
  placeholder?: string
  disabled?: boolean
  error?: string | null
  onChange: (value: string) => void
}

export function FormField({
  label,
  name,
  type = 'text',
  value,
  autoComplete,
  placeholder,
  disabled = false,
  error,
  onChange,
}: FormFieldProps) {
  const fieldId = useId()
  const errorId = `${fieldId}-error`

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={fieldId}>{label}</Label>
      <Input
        id={fieldId}
        name={name}
        type={type}
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
        invalid={Boolean(error)}
        describedBy={error ? errorId : undefined}
        onChange={onChange}
      />
      {error ? (
        <p id={errorId} className="text-xs text-accent">
          {error}
        </p>
      ) : null}
    </div>
  )
}
